/* ---------------------------------------------------------------- */
// Vendors Core
//-----------------------------------------------------------------
window.$ = require('jquery');
window.jQuery = require('jquery');
/* ---------------------------------------------------------------- */
// Bootstrap
//-----------------------------------------------------------------
import "bootstrap";
//-----------------------------------------------------------------

/* ---------------------------------------------------------------- */
// Vendors Plugins
//-----------------------------------------------------------------
import moment from 'moment';
window.moment = moment;
/* ---------------------------------------------------------------- */
// Sweetalert2
//-----------------------------------------------------------------
import Swal from 'sweetalert2';
window.Swal = Swal;
/* ---------------------------------------------------------------- */
// Chart.js
//-----------------------------------------------------------------
import Chart from "chart.js/auto";
window.Chart = Chart;
/* ---------------------------------------------------------------- */
// Datatables.net
//-----------------------------------------------------------------
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colvis.min.js";
import "jszip";
import  pdfMake from "pdfmake/build/pdfmake.min.js";
import  pdfFonts from "pdfmake/build/vfs_fonts.js";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
/* ---------------------------------------------------------------- */
// Select2
//-----------------------------------------------------------------
import Select2 from "select2";
window.Select2 = Select2;
/* ---------------------------------------------------------------- */
// Apps
//-----------------------------------------------------------------
import "./neoadmin/general.js";

